import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import { secondsToMMSS } from '../../../Common/Utils';
import { TaskModel, TaskType } from '../../../Models/Game/TaskModel';

export class MiniMapMiniGameController extends AnimationBaseController {
    $model: TaskModel;

    public constructor(@Inject private _options: any,
                       @Inject private _gameLogic: GameLogic) {
        super('MiniMapMiniGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.MINIMAP_SCREEN_JSON,
            libraryName: 'mini_map_pointer',
            modelWatch: {
                time: (value: number) => {
                    this.setTextByQuery('time', this.$model.type === TaskType.Regular ? secondsToMMSS(this.$model.time) : '');
                },
                index: (value: number) => {
                    this.setTextByQuery('index', this.$model.index.toString());
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this.$model.type === TaskType.Regular ? 'task_regular' : 'task_global');
        this.setTextByQuery('time', this.$model.type === TaskType.Regular ? secondsToMMSS(this.$model.time) : '');
        this.setTextByQuery('index', this.$model.index.toString());
    }
}
